(() => {
  'use strict';

  const section = document.querySelector('.nextdev--reading-progress-bar--section');
  const progressBar = section.querySelector('.nextdev--reading-progress-bar');

  const saleLineSection = document.querySelector('.nextdev--sale-line--section');  
  if (saleLineSection != null) {
    setTimeout(() => {
      section.style.top = saleLineSection.offsetHeight + 'px';
    }, 500);

    window.addEventListener('resize', () => {
      section.style.top = saleLineSection.offsetHeight + 'px';
    });
  }

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight;
    const totalHeight = document.documentElement.scrollHeight;
    const scrolled = (scrollTop / (totalHeight - viewportHeight)) * 100;

    progressBar.style.setProperty('--progress', scrolled + '%');
  });
})();
